// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8e6540e9","488":"07b1f7fe","796":"072b7995"}[chunkId] + ".chunk.js";
};